import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants - Functions
import { pathHomePage, WEB_SERVICE_MIMS, applications, protocols, primaryColor } from "../../../../../../config/constants";
import { getProtocolTitle, diagnosisProtocols } from "../../../../../../config/validateProtocols";
import { renderToolTip } from "../../../../../../config/functions";
// Components
import {
  MainDiv,
  Header,
  Title,
  OpenButton,
  OpenButtonImg,
  PlotDiv,
  AxisY,
  ActivitiesContainer,
  ActivityContainer,
  ActivityName,
  SessionsAligner,
  ReportsLink,
  ReportsImg,
  SessionsNumber,
} from "./styles";
import UseFetch from "../../../../../../config/useFetch";
// Assets
import ArrowUpImg from "../../../../../../assets/icons/ico_arrow_up_blue.svg";
import ArrowDownImg from "../../../../../../assets/icons/ico_arrow_down_blue.svg";
import ReportsIco from "../../../../../../assets/icons/ico_reports.svg";

const ActivitiesPerformedControlGroup = () => {
  const [showPlot, setShowPlot] = useState(false);
  const [protocolIds] = useState([...diagnosisProtocols.map((protocol) => protocol.id), protocols.clinicAndHome.PINBALL.id]);
  const [activitiesPerformed, setActivitiesPerformed] = useState([]);
  const { patientId } = useParams();
  const clinicianToken = useSelector(({ clinician }) => clinician.data.token);
  const [t] = useTranslation("global");

  // Fetching number of sessions by protocol
  useEffect(() => {
    UseFetch("get", `${WEB_SERVICE_MIMS}/sessions/get/${patientId}/${applications.clinic.name}`)
      .then(({ data }) => {
        setActivitiesPerformed((prevState) => [...prevState, ...data]);
      })
      .catch((error) => {
        console.log("Get number of sessions by protocol (RGS Clinic): ", error);
      });

    UseFetch("get", `${WEB_SERVICE_MIMS}/sessions/get/${patientId}/${applications.plus.name}`)
      .then(({ data }) => {
        setActivitiesPerformed((prevState) => [...prevState, ...data]);
      })
      .catch((error) => {
        console.log("Get number of sessions by protocol (RGS+): ", error);
      });

    return () => {
      setActivitiesPerformed([]);
    };
  }, [patientId]);

  const renderActivities = () => {
    return protocolIds.map((protocolId) => {
      const software = protocolId === protocols.clinicAndHome.PINBALL.id ? applications.clinic.name : applications.plus.name;
      const protocolTitle =
        protocolId === protocols.clinicAndHome.PINBALL.id
          ? `${t(getProtocolTitle("protocols", protocolId))} (RGSclinic)`
          : t(getProtocolTitle("protocols", protocolId));

      const filteredActivity = activitiesPerformed.filter((activity) => activity.PROTOCOL_ID === protocolId);
      const sessions = filteredActivity.length ? filteredActivity[0].sessionsNumber : 0;

      return (
        <ActivityContainer key={protocolId}>
          <ActivityName>{protocolTitle}</ActivityName>
          <SessionsAligner>
            <ReportsLink
              background={sessions > 0 ? primaryColor : "#808080"}
              to={`${pathHomePage}/reports/${clinicianToken}/${software}/${patientId}/${protocolId}`}
            >
              <ReportsImg src={ReportsIco} alt="reports-btn" />
            </ReportsLink>
            <SessionsNumber data-for="sessions" data-tip={`Number of sessions performed by activity: ${protocolTitle}`}>
              {!sessions ? "-" : sessions}
            </SessionsNumber>
          </SessionsAligner>
        </ActivityContainer>
      );
    });
  };

  return (
    <MainDiv>
      <Header>
        <Title>Activities performed</Title>
        <OpenButton onClick={() => setShowPlot(!showPlot)}>
          <OpenButtonImg src={showPlot ? ArrowUpImg : ArrowDownImg} alt="arrow-ico" />
        </OpenButton>
      </Header>
      {showPlot && (
        <PlotDiv>
          <AxisY>Activities</AxisY>
          <ActivitiesContainer>
            {renderActivities()}
            {renderToolTip("sessionsNumber")}
          </ActivitiesContainer>
        </PlotDiv>
      )}
    </MainDiv>
  );
};

export default ActivitiesPerformedControlGroup;
